import Repository from "./Repository";

const sendMailEnpoint = "/send-mail";

export default {
  sendMail: (mailData) => Repository.post(`${sendMailEnpoint}/`, mailData),
};
